import type { DocSection } from '../schema';
import { SECTIONS } from './meta';
import { pages as rmmPages } from './rmm';
import { pages as psaPages } from './psa';
import { pages as securityPages } from './security';
import { pages as crmPages } from './crm';
import { pages as cmsPages } from './cms';
import { pages as accountingPages } from './accounting';
import { pages as scriptingPages } from './scripting';
import { pages as automationsPages } from './automations';
import { pages as backupsPages } from './backups';
import { pages as aiAutonomyPages } from './ai-autonomy';
import { pages as phoneSystemPages } from './phone-system';
import { pages as apiPages } from './api';

const PAGES_BY_SECTION: Record<string, DocSection['pages']> = {
  rmm: rmmPages,
  psa: psaPages,
  security: securityPages,
  crm: crmPages,
  cms: cmsPages,
  accounting: accountingPages,
  scripting: scriptingPages,
  automations: automationsPages,
  backups: backupsPages,
  'ai-autonomy': aiAutonomyPages,
  'phone-system': phoneSystemPages,
  api: apiPages,
};

export const DOC_SECTIONS: DocSection[] = SECTIONS.map((meta) => ({
  ...meta,
  pages: PAGES_BY_SECTION[meta.id] ?? [],
}));

export function findSection(slug: string): DocSection | undefined {
  return DOC_SECTIONS.find((s) => s.slug === slug);
}

export function findPage(sectionSlug: string, pageSlug: string) {
  const section = findSection(sectionSlug);
  const page = section?.pages.find((p) => p.slug === pageSlug);
  return section && page ? { section, page } : undefined;
}

export function allPagesFlat(): { section: DocSection; page: DocSection['pages'][number] }[] {
  return DOC_SECTIONS.flatMap((section) => section.pages.map((page) => ({ section, page })));
}
